import React, { useContext } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import {
  FooterBox,
  FooterContainer,
  FotBoxRowOne,
  FotBoxOne,
  FotBoxFirst,
  FotBoxSecond,
  FotBoxCon,
  FooterContext,
  FooterLogo,
  FoLogoBox,
  AppIconBox,
  AppStoreIcon,
  GoogleStoreIcon,
  FooterDescText,
  FotBoxSocial,
  SocialIconBox,
  SocialText,
  InnerBoxOne,
  InnerBoxTwo,
} from "./NewFooterElements";
import { animateScroll as scroll } from "react-scroll";
import MenzilLogo from "../../../../images/menzill.png";
import AppStore from "../../../../images/apple-store-button.svg";
import GoogleStore from "../../../../images/google-play-button.svg";
import { LanguageContext } from "../../../../utils/language/Language";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { withRouter } from "react-router-dom";

const NewFooter = (props) => {
  const { userData, setUsers, defaultState, setDefaultState, toggle, history, notificationDataState } = props;
  //localization
  const { dictionary } = useContext(LanguageContext);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  console.log("mOMo", userData);

  return (
    <div>
      <FooterBox>
        <FooterContainer>
          <FotBoxRowOne>
            <InnerBoxOne>
              <FotBoxOne>
                <FoLogoBox>
                  <FooterLogo src={MenzilLogo} />
                </FoLogoBox>
                <FotBoxSecond>
                  {/* <FooterDescText>
                  {dictionary.menzilString.As_the_most}
                  </FooterDescText> */}
                  <AppIconBox>
                    <AppStoreIcon src={AppStore} />
                    <a href="https://play.google.com/store/apps/details?id=com.menzill" target="_blank">
                      <GoogleStoreIcon src={GoogleStore} />
                    </a>
                  </AppIconBox>
                </FotBoxSecond>
              </FotBoxOne>
            </InnerBoxOne>
            <InnerBoxTwo>
              <FotBoxOne>
                <FotBoxFirst>{dictionary.menzilString.Services}</FotBoxFirst>
                <FotBoxSecond>
                  <FotBoxCon href="/search-property?lat=28.6915175&long=77.0555796&sale_type=1&property_type=A">
                    {dictionary.menzilString.Buy_A_Home}
                  </FotBoxCon>
                  {userData?.role === "BUYER" ? (
                    ""
                  ) : (
                    <FotBoxCon
                      onClick={() => {
                        if (userData) {
                          if (userData?.role === "BUYER") {
                            history.push("/");
                          } else {
                            history.push("/post-property");
                          }
                        } else {
                          setDefaultState({ isSignup: false, isLogin: true });
                        }
                      }}
                    >
                      {dictionary.menzilString.Sell_A_Home}
                    </FotBoxCon>
                  )}

                  {/* <FotBoxCon>{dictionary.menzilString.Rent_A_Home}</FotBoxCon> */}
                </FotBoxSecond>
              </FotBoxOne>
              <FotBoxOne>
                <FotBoxFirst>{dictionary.menzilString.Get_to_Know}</FotBoxFirst>
                <FotBoxSecond>
                  <FotBoxCon href="/about-us">{dictionary.menzilString.About_Us}</FotBoxCon>
                  <FotBoxCon href="/contact-us">{dictionary.menzilString.Contact_Us}</FotBoxCon>
                  <FotBoxCon href="/privacy-policy">{dictionary.menzilString.Privacy_Policy}</FotBoxCon>
                  <FotBoxCon href="/term-condition">{dictionary.menzilString.Terms_Conditions}</FotBoxCon>
                </FotBoxSecond>
              </FotBoxOne>
              <FotBoxOne>
                <FotBoxFirst>{dictionary.menzilString.Let_us_Help}</FotBoxFirst>
                <FotBoxSecond>
                  <FotBoxCon
                    onClick={() =>
                      userData ? history.push("/my-profile") : setDefaultState({ isSignup: false, isLogin: true })
                    }
                  >
                    {dictionary.menzilString.Your_Account}
                  </FotBoxCon>
                  <FotBoxCon
                    onClick={() =>
                      userData ? history.push("/agent-finder") : setDefaultState({ isSignup: false, isLogin: true })
                    }
                  >
                    {dictionary.menzilString.Become_Agent}
                  </FotBoxCon>
                  <a href="/faq">
                    <FotBoxCon>{dictionary.menzilString.FAQ}</FotBoxCon>
                  </a>
                </FotBoxSecond>
              </FotBoxOne>
              {/* <FotBoxOne>
                <FotBoxFirst>{dictionary.menzilString.Connect_With_Us}</FotBoxFirst>
                <FotBoxSecond>
                  <FotBoxSocial>
                    <SocialIconBox>
                      <FaFacebookF style={{ color: "white" }} />
                    </SocialIconBox>
                    <SocialText>{dictionary.menzilString.Facebook}</SocialText>
                  </FotBoxSocial>
                  <FotBoxSocial>
                    <SocialIconBox>
                      <FaTwitter style={{ color: "white" }} />
                    </SocialIconBox>
                    <SocialText>{dictionary.menzilString.Twitter}</SocialText>
                  </FotBoxSocial>
                  <FotBoxSocial>
                    <SocialIconBox>
                      <FaInstagram style={{ color: "white" }} />
                    </SocialIconBox>
                    <SocialText>{dictionary.menzilString.Instagram}</SocialText>
                  </FotBoxSocial>
                  <FotBoxSocial>
                    <SocialIconBox>
                      <FaLinkedinIn style={{ color: "white" }} />
                    </SocialIconBox>
                    <SocialText>{dictionary.menzilString.Linkedin}</SocialText>
                  </FotBoxSocial>
                </FotBoxSecond>
              </FotBoxOne> */}
            </InnerBoxTwo>
          </FotBoxRowOne>
          <FotBoxRowOne style={{ justifyContent: "center" }}>
            <FooterContext>{dictionary.menzilString.Copyright_text}</FooterContext>
          </FotBoxRowOne>
        </FooterContainer>
      </FooterBox>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    notificationDataState: state.notificationData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewFooter));
